import type { IOTFCutOffTable } from "../../types/iotf.types";
import { iotfCutOffsV1 } from "./iotf-cutoffs";

export const iotfRegistry: Record<string, IOTFCutOffTable> = {
  "iotf-cutoffs-v1": iotfCutOffsV1,
};

export function getIOTFTable(tableId: string): IOTFCutOffTable {
  const table = iotfRegistry[tableId];
  if (!table) {
    throw new Error(
      `IOTF table not found: ${tableId}. Register it in iotfRegistry before use.`
    );
  }
  return table;
}
